<template>
  <div
    :disabled="disabled || loading">
    <slot name="loading">
      <i v-if="loading" class="fa fa-spinner fa-spin"></i>
    </slot>
    <slot></slot>
    <div class="col-md-6 col-12">
      <div v-for="(item, index) in posts_list">
        <PostElement :title="item.title.rendered"></PostElement>
      </div>
    </div>
  </div>
</template>
<script>
import {blog} from "@/_services";
import {PostElement} from "@/components/index";

export default {
  name: 'postList',
  props: {
    loading: Boolean,
    disabled: Boolean,
  },
  components: {
    PostElement
  },
  data() {
    return {
      posts_list: [],
      datos: ''
    };
  },
  async mounted() {
    var blogApi = new blog.WpApi
    this.posts_list = await blogApi.posts(1)
  }
};
</script>
<style>
</style>
